
import { useState } from 'react';
import { useAuthStore } from '@/store/authStore';
import { UserRole } from '@/types';

export function useUsers() {
  const { users, addUser, updateUserPhone, updateUserPassword, deleteUser } = useAuthStore();
  const [showAddDialog, setShowAddDialog] = useState(false);

  const handleAddUser = (userData: { 
    username: string; 
    phoneNumber: string; 
    role: UserRole;
  }) => {
    // Create new user without password - it will be set later
    addUser({
      ...userData,
      id: Math.random().toString(36).substr(2, 9),
      permissions: userData.role === 'admin' ? ['*'] : ['view', 'add']
    });
  };

  return {
    users,
    showAddDialog,
    setShowAddDialog,
    handleAddUser,
    handleUpdatePhone: updateUserPhone,
    handleUpdatePassword: updateUserPassword,
    handleDeleteUser: deleteUser,
  };
}
